import React, { type ReactNode } from 'react';
import { type StyleProp, StyleSheet, View, type ViewStyle } from 'react-native';

import { theme } from '@garnish/constants';

import { BodyText } from '../../../Text';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductCardV2Notice = (props: Props) => {
  return (
    <View style={[styles.container, props.style]}>
      <BodyText sizeMatch={['12']} style={styles.text}>
        {props.children}
      </BodyText>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    alignSelf: 'flex-start',
    gap: theme.spacing['1'],
    borderRadius: theme.radius.xlarge,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
    paddingVertical: 2,
    paddingHorizontal: theme.spacing['2'],
  },
  text: {
    color: theme.colors.CHARCOAL,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  children: ReactNode;
  style?: StyleProp<ViewStyle>;
};
